import {TFunction} from "i18next";
import StringHelper from "../../../../services/Common/StringHelper";
import {ConfigApi, OrderSchedulingMode} from "../../../../services/Api/types";
import StoreUtils from "../../../../services/Store/StoreUtils";
import DateService from "../../../../services/Common/Date/DateService";
import {DateHelper, getWeekDay} from "../../../../services/Common/Date/DateHelper";

const getDateFormat = (today: Date, i: number, t: TFunction, session: Record<string, any>) => {
    if (i === 0) return t("common.word.today");
    if (i === 1) return t("common.word.tomorrow");

    const weekDayName = getWeekDay(today, session.locale, true);
    const day = today.getDate();
    const month = today.getMonth() + 1;
    let monthString = month.toString();
    let dayString = day.toString();

    if (day < 10) {
        dayString = '0' + day;
    }

    if (month < 10) {
        monthString = '0' + month;
    }

    return `${weekDayName}, ${dayString}.${monthString}`;
}

const isValidDate = (dates: { date_from: Date, date_to: Date }[], date: Date, weekDays?: string[]) => {
    if (weekDays) {
        const weekdayNumber = date.getDay();
        const weekDayNumbers = weekDays.map((weekDay: any) => StringHelper.getDayOfWeekNumber(weekDay));
        if (!weekDayNumbers.includes(weekdayNumber)) return false;
    }

    if (!dates) {
        return true;
    }

    return dates.some((item) => {
        return date >= item.date_from && date <= item.date_to;
    })
}

export const getPickUpDateDrawerDateOptions = (session: Record<string, any>, config: ConfigApi | undefined, t: TFunction, dates: {
    date_from: Date,
    date_to: Date
}[], weekDays?: string[]) => {
    const onlyToday = StoreUtils.getOrderSchedulingMode(config) === OrderSchedulingMode.SAME_DAY;
    const today = DateService.now();
    const finalDates: { label: string, value: string }[] = [];
    const min = 0;
    const max = onlyToday ? 0 : 61;

    for (let i = min; i <= max; i++) {
        if (i > 0) {
            today.setDate(today.getDate() + 1);
        }
        if (!isValidDate(dates, today, weekDays)) {
            continue;
        }

        finalDates.push({
            value: DateHelper.formatOnlyDate(today),
            label: getDateFormat(today, i, t, session)
        })
    }
    return finalDates;
}